import {
  ExpensesLegalEntitiesConnectionDocument,
  ExpensesLegalEntitiesConnectionQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type LegalEntity =
  ExpensesLegalEntitiesConnectionQuery['companies']['legalEntitiesConnection']['nodes'][number]

const useLegalEntities = () => {
  const { data, loading } = useQuery(ExpensesLegalEntitiesConnectionDocument, {
    fetchPolicy: 'cache-first',
  })
  const legalEntities = data?.companies?.legalEntitiesConnection.nodes ?? []
  const mainLegalEntity = legalEntities?.find((node) => node.main == true)
  return {
    legalEntities,
    mainLegalEntity,
    loading,
  }
}

export default useLegalEntities
